import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  activeJobDetails: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});
